export const SuggestedLocations = [
    // Borough
    { type: 'borough', borough: 'Brooklyn' },
    // Neighborhood (Manhattan)
    {
        type: 'neighborhood',
        id: 'e1025406-5900-4e20-97a8-b8c85e6ec3d7', // TODO: fill in
        name: 'Upper West Side',
        borough: 'Manhattan',
        city: 'New York',
        slug: 'upper-west-side',
        parentId: 'a0892ed4-6286-4ca3-bf79-922b4861b297', // TODO: fill in
        childrenIds: [], // TODO: fill in
    },
    // Address (Queens)
    {
        type: 'address',
        id: '4618772-4009160010',
        buildingId: '4618772-4009160010',
        buildingSlug: '4618772-4009160010',
        slug: 'queens-astoria-30-halletts-point-11102',
        streetAddress: '30 Halletts Point',
        fullAddress: '30 Halletts Point, Queens, New York, NY 11102',
        cityId: 'nyc',
    },
    // Building name (Queens)
    {
        type: 'building',
        id: '4619459-4004360001',
        buildingId: '4619459-4004360001',
        buildingSlug: '4619459-4004360001',
        slug: 'queens-hunters-point-23-15-44-rd-11101',
        name: 'Lumen LIC',
        streetAddress: '23-15 44th Road',
        fullAddress: '23-15 44th Road, Queens, New York, NY 11101',
        cityId: 'nyc',
    },
];
